<template>
  <el-form
    :model="form"
    :rules="rules"
    :disabled="disabled"
    ref="form"
    label-width="110px"
  >
    <section>
      <div class="section-title">
        任务信息
        <span v-if="form.id">(id: {{ form.id }})</span>
      </div>

      <el-row>
        <el-col :span="6">
          <el-form-item label="上架申请标题" prop="taskName">
            <el-input v-model="form.taskName" placeholder="请输入" class="form-field"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="采买任务名称/ID" prop="buyId" label-width="120px">
            <div class="search-buy-task-wrapper">
              <search-buy-task :value.sync="form.buyId" width="390px" @select="handleSelectBuyInfo"></search-buy-task>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="采买类型" prop="buyType">
            <el-select v-model="form.buyType" placeholder="请选择" class="form-field">
              <el-option
                v-for="(label, value) in buyTypeMap"
                :key="+value"
                :label="label"
                :value="+value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="内容组别" prop="contentType">
            <el-select v-model="form.contentType" placeholder="请选择" class="form-field">
              <el-option
                v-for="(label, value) in contentTypeMap"
                :key="+value"
                :label="label"
                :value="+value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="签约类型" prop="contractType">
            <el-select v-model="form.contractType" placeholder="请选择" class="form-field">
              <el-option
                v-for="(label, value) in contractTypeMap"
                :key="+value"
                :label="label"
                :value="+value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item label="版权方" prop="cpCompanyId">
            <search-company
              :value.sync="form.cpCompanyId"
              placeholder="请输入"
              class="form-field"
            ></search-company>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="外显厂牌方" prop="disCompanyId">
            <search-company
              :value.sync="form.disCompanyId"
              placeholder="请输入"
              class="form-field"
            ></search-company>
          </el-form-item>
        </el-col> -->
      </el-row>
    </section>

    <section>
      <div class="section-title">合同信息</div>
      <copyright-form
        ref="contractForm"
        :contract="form"
        :disabled="disabled"
        @select="handleSelectBuyInfo"
      ></copyright-form>
    </section>

    <section>
      <div class="section-title">
        <span>权利信息</span>
        <el-button
          icon="el-icon-plus"
          size="mini"
          class="add-material-btn"
          @click="handleAddDetail"
        >
          新增权利
        </el-button>
      </div>
      <copyright-detail-list
        class="mb-16"
        :detail-list="form.copyrightDetailList"
        :current="form.copyrightDetailList.length"
        @remove="handleRemoveDetail"
      ></copyright-detail-list>
    </section>

    <section>
      <div class="section-title">内容基础信息</div>
      <el-row>
        <el-col :span="6">
          <el-form-item label="歌曲上架方式" prop="audioBase.insertType">
            <el-select v-model="form.audioBase.insertType" class="form-field" placeholder="请选择">
              <el-option
                v-for="(label, value) in insertTypeMap"
                :key="+value"
                :label="label"
                :value="+value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="授权类型" prop="audioBase.batchAuthType">
            <el-select v-model="form.audioBase.batchAuthType" class="form-field" placeholder="请选择">
              <el-option
                v-for="(label, value) in batchAuthTypeMap"
                :key="+value"
                :label="label"
                :value="+value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="歌曲数量" prop="audioBase.songsCnt">
            <el-input-number
              v-model="form.audioBase.songsCnt"
              class="form-field"
              :controls="false"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="伴奏数量" prop="audioBase.kTrackCnt">
            <el-input-number
              v-model="form.audioBase.kTrackCnt"
              class="form-field"
              :controls="false"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="视频数量" prop="audioBase.mvCnt">
            <el-input-number
              v-model="form.audioBase.mvCnt"
              class="form-field"
              :controls="false"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="付费模式" prop="audioBase.paymentModeId">
            <el-select v-model="form.audioBase.paymentModeId" class="form-field" placeholder="请选择">
              <el-option
                v-for="(label, value) in paymentModeMap"
                :key="+value"
                :label="label"
                :value="+value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="付费转库时间" prop="audioBase.paymentTransTime">
            <el-date-picker
              v-model="form.audioBase.paymentTransTime"
              style="width: 190px;"
              type="datetime"
              default-time="23:59:59"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </section>

    <section>
      <div class="section-title">
        <span>歌曲物料信息</span>
        <el-button
          icon="el-icon-plus"
          size="mini"
          class="add-material-btn"
          @click="handleAddTrack"
        >
          添加物料
        </el-button>
      </div>
      <material-list
        class="mb-16"
        :audio-list="form.audioInfo"
        :current="form.audioInfo.length"
        @remove="handleRemoveTrack"
      ></material-list>
    </section>

    <!-- <section>
      <div class="section-title">
        <span>MV物料信息</span>
        <el-button
          icon="el-icon-plus"
          size="mini"
          class="add-material-btn"
          @click="handleAddMv"
        >
          添加物料
        </el-button>
      </div>
      <material-list
        class="mb-16"
        type="mv"
        :audio-list="form.mvInfo"
        :current="form.mvInfo.length"
        @remove="handleRemoveMv"
      ></material-list>
    </section> -->

    <!-- <section>
      <div class="section-title">修改记录</div>
      <modified-table class="mb-16" :records="form.modifyRecords"></modified-table>
    </section> -->

    <section>
      <div class="section-title">备注</div>
      <comments :comment.sync="form.comment" :list="form.commentList"></comments>
    </section>

    <div v-if="!disabled" class="center">
      <el-button type="primary" :loading="loading" @click="handleSubmit"> 提 交 </el-button>
    </div>
  </el-form>
</template>

<script>
import SearchBuyTask from '@/components/SearchBuyTask'
import { CpDetail } from '@/models/Contract'
import { CpTask, defaultAudioBatchObj } from '@/models/CpTask'
import CopyrightForm from './CopyrightForm.vue'
import MaterialList from './MaterialList/index.vue'
import CopyrightDetailList from './CopyrightDetailList/index.vue'
// import ModifiedTable from './ModifiedTable.vue'
import Comments from './Comments.vue'
import {
  MATERIAL_ENUM,
  validMap,
  buyTypeMap,
  companyTypeMap,
  contentTypeMap,
  contractTypeMap,
  insertTypeMap,
  batchAuthTypeMap,
  paymentModeMap,
  settleMethodMap,
  tmePartyMap,
  settleTypeMap,
} from '../../const'

function toNumberArray(str) {
  if (!str || typeof str !== 'string') return []
  return str.split(',').filter(Boolean).map(Number)
}

function getNumberOrUnf(str, defaultValue = undefined) {
  return +str ? +str : defaultValue
}

export default {
  name: 'TaskForm',
  components: {
    SearchBuyTask,
    CopyrightForm,
    MaterialList,
    CopyrightDetailList,
    // ModifiedTable,
    Comments
  },
  props: {
    detail: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      validMap,
      buyTypeMap,
      companyTypeMap,
      contentTypeMap,
      contractTypeMap,
      insertTypeMap,
      batchAuthTypeMap,
      paymentModeMap,
      settleMethodMap,

      form: null,
      rules: {
        taskName: [
          {
            required: true,
            message: '请输入上架申请标题',
            trigger: 'blur',
          },
        ],
        contract: [
          {
            required: true,
            message: '请输入合同编号',
            trigger: 'blur',
          },
        ],
        contentType: [
          {
            required: true,
            message: '请选择内容组别',
            trigger: 'change',
          }
        ],
        contractType: [
          {
            required: true,
            message: '请选择签约类型',
            trigger: 'change',
          }
        ],
        'audioBase.insertType': [
          {
            required: true,
            message: '请选择上架方式',
            trigger: 'change',
          }
        ],
        'audioBase.batchAuthType': [
          {
            required: true,
            message: '请选择物料授权类型',
            trigger: 'change',
          }
        ],
        'audioBase.paymentModeId': [
          {
            required: true,
            message: '请选择付费模式',
            trigger: 'change',
          }
        ],
      }
    }
  },

  watch: {
    detail: {
      immediate: true,
      handler() {
        this.form = new CpTask(this.detail)
      }
    }
  },

  methods: {
    // 把采买任务字段映射成版权入库任务字段
    formatData(originData) {
      const formatData = new CpTask()
      const remarkList = []
      // 处理任务字段
      formatData.taskName = originData.taskName
      formatData.buyId = `${originData.id} -@- ${originData.taskName}`
      // 处理采买单状态
      formatData.buyStatus = originData.status
      // contractType 签约类型，新增
      formatData.contractType = getNumberOrUnf(originData.contractType)
      // purchaseType 采买类型
      formatData.buyType = getNumberOrUnf(originData.purchaseType, 0)

      // 处理合同字段
      // authType 合同类型，放到对应字段备注中
      // authTypeRemarks 和上面拼接
      formatData.copyrightExtend.authTypeRemarks = `${originData.authType};${originData.authTypeRemarks}`
      // companyName 授权方
      formatData.authorizer = originData.companyName
      remarkList.push(`版权方：${originData.companyName}`)
      // companyType 合同公司类型
      formatData.companyType = getNumberOrUnf(originData.companyType, 0)
      // contentType 合同来源 放到合同备注中
      formatData.contentType = getNumberOrUnf(originData.contentType, 0)
      remarkList.push(`合同来源：${contentTypeMap[originData.contentType]}`)
      // tmeParty 当前被授权主体 放到合同备注中
      remarkList.push(`当前被授权主体：${originData.tmeParty} -@- ${tmePartyMap[originData.tmeParty]}`)
      // displayCompany 外显厂牌方 放到合同备注中
      remarkList.push(`外显厂牌方：${originData.displayCompany}`)
      // businessBroker 商务负责人
      formatData.businessBroker = originData.businessBroker
      // contract、virContractNo 合同编号以前者为准，无前者用后者
      if (originData.contract) {
        formatData.contract = originData.contract
      } else if (originData.virContractNo) {
        formatData.contract = originData.virContractNo
        formatData.isVirtual = 1
      }
      // noLink 是否禁止\限制链接 放到对应字段备注中
      formatData.copyrightExtend.noLinkRemarks = originData.noLink
      // originContract 原合同编号，不外显映射
      // originalCopyrightFrom 原始授权开始时间
      // originalCopyrightTo 原始授权结束时间
      formatData.originalDate = [originData.originalCopyrightFrom, originData.originalCopyrightTo]
      // payCheckCondition 结算条件
      formatData.settleTerms = originData.payCheckCondition
      // settleType 结算方式，放到对应字段备注中
      formatData.copyrightExtend.settleMethodRemarks = settleTypeMap[originData.settleType]
      // signBusinessTeam 签约商务团队
      formatData.signBusinessTeam = getNumberOrUnf(originData.signBusinessTeam, 0)
      // tmeParty 当前被授权主体 拼到合同备注中

      // 处理内容基础信息
      // estimateTrackCount 歌曲数量
      formatData.audioBase.songsCnt = originData.estimateTrackCount
      // descriptionOnlineSongs 歌曲数量备注，无
      // saleModeAnotherStorageTime 付费转库时间
      formatData.audioBase.paymentTransTime = originData.saleModeAnotherStorageTime
      // saleModeDiscuss 付费模式
      formatData.audioBase.paymentModeId = getNumberOrUnf(originData.saleModeDiscuss)

      // 合同备注整合
      formatData.copyrightExtend.remarks = remarkList.join('；')

      // 处理权利字段
      const copyrightDetail = formatData.copyrightDetailList[0]
      // authForm 授权形式
      copyrightDetail.authForm = toNumberArray(originData.authForm)
      // authArea 授权区域
      copyrightDetail.copyrightArea = toNumberArray(originData.authArea)
      // authPlatform 授权平台
      copyrightDetail.authProduct = toNumberArray(originData.authPlatform)
      // authTerminal 授权终端
      copyrightDetail.authTerminal = toNumberArray(originData.authTerminal)
      // canAtUse 硬件厂商合作
      copyrightDetail.cooFactory = [originData.canAtUse].filter(Boolean)
      // canAtUseRemarks 硬件厂商合作备注
      copyrightDetail.copyrightDetailExtend.cooFactoryRemarks = originData.canAtUseRemarks
      // canClip 是否可剪辑
      // canClipRemarks 是否可剪辑备注
      if (originData.canClip) {
        copyrightDetail.canClip = 1
        copyrightDetail.copyrightDetailExtend.canClipRemarks = originData.canClip
      }
      // excludePlatform 排除平台，放到对应字段备注中
      copyrightDetail.copyrightDetailExtend.excludePlatformRemarks = originData.excludePlatform
      // launchTypeDiscuss 是否首发
      // launchTypeDiscussRemarks 是否首发备注
      copyrightDetail.copyrightDetailExtend.isOnlyRemarks = `${originData.launchTypeDiscuss}；${originData.launchTypeDiscussRemarks}`
      if (originData.launchTypeDiscuss && !originData.launchTypeDiscuss.includes('非')) {
        copyrightDetail.isOnly = 1
      } else {
        copyrightDetail.isOnly = 0
      }

      // launchDay 首发天数
      // launchDayRemarks 首发天数备注，不外显映射
      if (originData.launchDay) {
        copyrightDetail.onlyWholeTime = 0
        copyrightDetail.onlyDuration = originData.launchDay
      } else {
        copyrightDetail.onlyWholeTime = 1
      }
      // network 传播网络
      copyrightDetail.network = toNumberArray(originData.network)
      // otherRight 其他权利
      copyrightDetail.otherRight = toNumberArray(originData.otherRight)
      // srcInReceiver 音源直接内置至接收终端
      copyrightDetail.srcInReceiver = getNumberOrUnf(originData.srcInReceiver, 0)
      // srcInReceiverRemarks 音源直接内置至接收终端备注，不外显映射

      return formatData
    },
    handleSelectBuyInfo(item) {
      if (!item) {
        return this.$message({
          type: 'error',
          message: '拉取采买任务失败'
        })
      }
      this.form = this.formatData(item)
    },
    handleAddTrack() {
      this.form.audioInfo.push(defaultAudioBatchObj(MATERIAL_ENUM.TRACK.code))
    },
    handleRemoveTrack(index) {
      this.form.audioInfo.splice(index, 1)
    },
    handleAddMv() {
      this.form.mvInfo.push(defaultAudioBatchObj(MATERIAL_ENUM.MV.code))
    },
    handleRemoveMv(index) {
      this.form.mvInfo.splice(index, 1)
    },
    handleAddDetail() {
      this.form.copyrightDetailList.push(new CpDetail())
    },
    handleRemoveDetail(index) {
      this.form.copyrightDetailList.splice(index, 1)
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
        await this.$refs.contractForm.validate()
        // 这里拆分了多个子组件，但因为传的是对象引用类型，所以直接修改了源对象
        const postData = this.form.getBackendData()

        // console.log(postData)
        this.$emit('submit', postData)
      } catch (error) {
        console.error(error)
        const invalid = error[Object.keys(error)[0]]
        this.$message({
          type: 'warning',
          message: invalid[0].message
        })
      }
    }
  }
}
</script>

<style>
.search-buy-task-wrapper {
  display: flex;
  align-items: center;
}
.form-field {
  width: 140px;
}
.small-form-field {
  width: 120px;
}
.section-title {
  padding: 0 4px;
  font-size: 15px;
}
.add-material-btn {
  margin-left: 10px;
}

.mb-16 {
  margin-bottom: 16px;
}
</style>
